<template>
  <el-table :class="$style.table" :data="tableData" :summary-method="getSummaries" show-summary>
    <el-table-column :formatter="dateFormat" label="Дата" width="120"/>
    <el-table-column :formatter="row => row.direction === 1 ? formatNumber(row.total) : ''" label="Приход" width="150px"/>
    <el-table-column :formatter="row => row.direction === 0 ? formatNumber(row.total) : ''" label="Расход" width="150px"/>
    <!--              <el-table-column label="Потребление услуг">-->
    <!--                -->
    <!--              </el-table-column>-->
    <el-table-column prop="description" label="Основание" min-width="150" v-if="descriptionVisible"/>
    <el-table-column :formatter="row => formatNumber(row.direction === 0 ? row.min_balance : row.max_balance)" label="Баланс" min-width="150"/>
  </el-table>
</template>

<script>
import moment from "moment"

export default {
  name: "FinanceMovementReportTable",
  props: ["tableData", "descriptionVisible"],
  methods: {
    dateFormat(row) {
      return moment(row.cat).format("DD.MM.YYYY")
    },
    getSummaries() {
      let finals = this.tableData.reduce((acc, r) => {
        if (r.direction === 0) acc.down += Number(r.total)
        else acc.up += Number(r.total)
        return acc
      }, {up: 0, down: 0})
      //let lastOp = this.tableData.length ? this.tableData[this.tableData.length - 1] : null
      return [
        "Итого",
        `${this.formatNumber(finals.up)} руб.`,
        `${this.formatNumber(finals.down)} руб.`,
        "",
        ""//lastOp ? `${this.formatNumber(lastOp.direction === 0 ? lastOp.min_balance : lastOp.max_balance)} руб.` : '0.00 руб.'
      ]
    },
  }
}
</script>

<style lang="css" module>
.table{
  width: 100%;
  margin-bottom: 50px;
  margin-top: 50px;
}
</style>